/* -------------------------------------------------------------------------- */
/*                                    页面权限                                 */
/* -------------------------------------------------------------------------- */

// 组织架构
export const ORGANIZATION_PAGE_UUID = '4014a745-a3c0-4a12-9bd2-d3bf2a98480c'

/* -------------------------------------------------------------------------- */
/*                                    操作权限                                 */
/* -------------------------------------------------------------------------- */

// 管理部门
export const ORGANIZATION_DEPT_ACTION_UUID =
  '2b443340-fde7-4212-a1b2-6a2e339f0c08'

// 管理用户
export const ORGANIZATION_USER_ACTION_UUID =
  'fcdd8b15-3ddb-4fdb-b14f-4543f5d37cc3'
